//字符函数--29个
export const StringFunc = [
  {
    "key": "StringSubstring",
    "name": "取子字符串"
  },
  {
    "key": "SubString",
    "name": "取子字符串",
    "params": [
      {
        "key": "data",
        "name": "源字符串",
        "type": "str"
      },
      {
        "key": "start",
        "name": "起始位置",
        "type": "int"
      },
      {
        "key": "length",
        "name": "長度",
        "type": "int"
      }
    ],
    "description": `【功能】：從字符串中指定位置開始，截取指定長度的字符串並返回\n【返回值類型】：字符串(String)\n【示例】：取子字符串("ABCDEFG",2,3)【返回值】："CDE"`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringLength",
    "name": "取字符串長度"
  },
  {
    "key": "Length",
    "name": "取字符串長度",
    "params": [
      {
        "key": "data",
        "name": "源字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：獲取字符串的長度\n【返回值類型】：數值(Int32)\n【示例】：取字符串長度("ABCDEF")【返回值】：6`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "Contains",
    "name": "是否包含",
    "params": [
      {
        "key": "data",
        "name": "源字符串",
        "type": "str"
      },
      {
        "key": "target",
        "name": "目標字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：判斷字符串中是否包含目標字符串\n【返回值類型】：布爾(Boolean)\n【示例】：是否包含(salesorder.code,"表達式")【返回值】：false`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "NotContains",
    "name": "是否不包含",
    "params": [
      {
        "key": "data",
        "name": "字符串",
        "type": "str"
      },
      {
        "key": "target",
        "name": "目標字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：判斷字符串中是否不包含目標字符串\n【返回值類型】：布爾(Boolean)\n【示例】：是否不包含(salesorder.code,"表達式")【返回值】：true`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StartsWith",
    "name": "開頭是",
    "params": [
      {
        "key": "data",
        "name": "源字符串",
        "type": "str"
      },
      {
        "key": "target",
        "name": "目標字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：判斷字符串是否以目標字符串開頭\n【返回值類型】：布爾(Boolean)\n【示例】：開頭是(salesorder.code,"表達式")【返回值】：false`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "NotStartsWith",
    "name": "開頭不是",
    "params": [
      {
        "key": "data",
        "name": "字符串",
        "type": "str"
      },
      {
        "key": "target",
        "name": "目標字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：判斷字符串是否不以目標字符串開頭\n【返回值類型】：布爾(Boolean)\n【示例】：開頭不是(salesorder.code,"表達式")【返回值】：true`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "EndsWith",
    "name": "結尾是",
    "params": [
      {
        "key": "data",
        "name": "源字符串",
        "type": "str"
      },
      {
        "key": "target",
        "name": "目標字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：判斷字符串是否以目標字符串結尾\n【返回值類型】：布爾(Boolean)\n【示例】：結尾是(salesorder.code,"表達式")【返回值】：false`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "NotEndsWith",
    "name": "結尾不是",
    "params": [
      {
        "key": "data",
        "name": "字符串",
        "type": "str"
      },
      {
        "key": "target",
        "name": "目標字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：判斷字符串是否不以目標字符串結尾\n【返回值類型】：布爾(Boolean)\n【示例】：結尾不是(salesorder.code,"表達式")【返回值】：false`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringReplace",
    "name": "字符串替換"
  },
  {
    "key": "Replace",
    "name": "字符串替換",
    "params": [
      {
        "key": "data",
        "name": "源字符串",
        "type": "str"
      },
      {
        "key": "oldVal",
        "name": "被替換值",
        "type": "str"
      },
      {
        "key": "newVal",
        "name": "替換值",
        "type": "str"
      }
    ],
    "description": `【功能】：將字符串中的"被替換值"替換為"替換值"\n【返回值類型】：字符串(String)\n【示例】：字符串替換("123412","12","00")【返回值】："003400"`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringToUpper",
    "name": "轉大寫"
  },
  {
    "key": "ToUpper",
    "name": "轉大寫",
    "params": [
      {
        "key": "data",
        "name": "源字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：將源字符串轉換為大寫\n【data】：源字符串\n【返回值類型】：字符串(System.String)\n【示例】：ToUpper("abc")\n【返回值】："ABC"`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringToLower",
    "name": "轉小寫"
  },
  {
    "key": "ToLower",
    "name": "轉小寫",
    "params": [
      {
        "key": "data",
        "name": "源字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：將源字符串轉換為小寫\n【data】：源字符串\n【返回值類型】：字符串(System.String)\n【示例】：ToLower("ABC")\n【返回值】："abc"`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringIndexOf",
    "name": "首個匹配字符索引"
  },
  {
    "key": "IndexOf",
    "name": "首個匹配字符索引",
    "params": [
      {
        "key": "data",
        "name": "源字符串",
        "type": "str"
      },
      {
        "key": "target",
        "name": "目標字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：在字符串中檢索目標字符串，找到首個匹配的字符串並返回索引位置(從0開始)。如果未找到則返回-1，如果目標字符串為空則返回0，如果原字符串為null則返回-1\n【返回值類型】：數值(Int32)\n【示例】：首個匹配字符索引("12001234012","01")【返回值】：3\n【示例】：首個匹配字符索引("12002323","34")【返回值】：-1\n【示例】：首個匹配字符索引("120011","")【返回值】：0`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringLastIndexOf",
    "name": "最後匹配字符索引"
  },
  {
    "key": "LastIndexOf",
    "name": "最後匹配字符索引",
    "params": [
      {
        "key": "data",
        "name": "源字符串",
        "type": "str"
      },
      {
        "key": "target",
        "name": "目標字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：在字符串中檢索目標字符串，找到最後一個匹配的字符串後返回索引位置(從0開始)。如果未找到則返回-1，如果目標字符串為空串則返回原字符串長度，如果原字符串為null則返回-1\n【返回值類型】：數值(Int32)\n【示例】：最後匹配字符索引("12001234012","01")【返回值】：8\n【示例】：最後匹配字符索引("12002323","34")【返回值】：-1\n【示例】：最後匹配字符索引("120011","")【返回值】：6`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringTrimStart",
    "name": "刪除頭部空格"
  },
  {
    "key": "TrimStart",
    "name": "刪除頭部空格",
    "params": [
      {
        "key": "data",
        "name": "源字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：刪除字符串的頭部空格並返回\n【返回值類型】：字符串(String)\n【示例】：刪除頭部空格("    ABC")【返回值】："ABC"`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringTrimEnd",
    "name": "刪除尾部空格"
  },
  {
    "key": "TrimEnd",
    "name": "刪除尾部空格",
    "params": [
      {
        "key": "data",
        "name": "源字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：刪除字符串的尾部空格並返回\n【返回值類型】：字符串(String)\n【示例】：刪除尾部空格("ABC    ")【返回值】："ABC"`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringTrim",
    "name": "刪除頭尾部空格"
  },
  {
    "key": "Trim",
    "name": "刪除頭尾部空格",
    "params": [
      {
        "key": "data",
        "name": "源字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：刪除字符串的頭尾部空格並返回\n【返回值類型】：字符串(String)\n【示例】：刪除頭尾部空格("    ABC    ")【返回值】："ABC"`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "CreateGuid",
    "name": "唯一標識符",
    "params": [],
    "description": `【功能】：獲取唯一標識符Guid\n【返回值類型】：字符串(String)\n【示例】：唯一標識符()【返回值】："7722A793-14DF-49CD-B7E7-DF4987YYD2"`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringAdd",
    "name": "字符串相加"
  },
  {
    "key": "Add",
    "name": "字符串相加",
    "params": [
      {
        "key": "str1",
        "name": "第一個字符串",
        "type": "str"
      },
      {
        "key": "str2",
        "name": "第二個字符串",
        "type": "str"
      }
    ],
    "description": `【功能】：將若干字符串拼接成一個新字符串，最多支持10個字符串拼接，最少2個；編輯器中默認插入兩個，多個字符串可手動添加\n【返回值類型】：字符串(String)\n【示例】：字符串相加("Hello","World")【返回值】："HelloWord"`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  }
]
